module.exports = "<report-summary-admin *ngIf=\"user.role !== Roles.Agent\"></report-summary-admin>\n<report-summary-agent *ngIf=\"user.role == Roles.Agent\"></report-summary-agent>`\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/reportv2/summary/summary.component.html
// module id = ./src/app/pages/admin/icontact/reportv2/summary/summary.component.html
// module chunks = main